import { useMemo } from 'react'
import { Moment } from 'moment-timezone'

import { getMonthInGenitiveCase } from 'app/i18n'

import { Status } from './statusProps'


type Props = {
  action: Status | null
  mDate: Moment
}

export const HeaderOrgsKits = ({ mDate, action }: Props) => {
  const header = useMemo(() => {
    if (!mDate || !mDate.isValid() || !action) {
      return 'Комплекты'
    }
    if (action === Status.Archived) {
      return 'Архив комплектов'
    }

    const day = Number(mDate.format('D'))
    const monthNumber = Number(mDate.format('M'))
    const year = mDate.format('YYYY')

    const monthInGenitiveCase = getMonthInGenitiveCase(monthNumber)
    return `Комплекты от ${day} ${monthInGenitiveCase} ${year}`
  }, [mDate, action])

  return header
}
